var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "truck",
    transform: "translate(-203 -137)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_26",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 26",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(203 137)",
    fill: "#3a4557"
  }), /*#__PURE__*/React.createElement("path", {
    id: "solid_truck",
    "data-name": "solid truck",
    d: "M17.063,9.625h-.437V6.669a1.313,1.313,0,0,0-.386-.927L13.508,3.011a1.313,1.313,0,0,0-.927-.386H11.375V1.313A1.313,1.313,0,0,0,10.063,0H1.313A1.313,1.313,0,0,0,0,1.313v8.75a1.313,1.313,0,0,0,1.313,1.313H1.75a2.625,2.625,0,0,0,5.25,0h3.5a2.625,2.625,0,0,0,5.25,0h1.313a.439.439,0,0,0,.438-.438v-.875A.439.439,0,0,0,17.063,9.625ZM4.375,12.688a1.313,1.313,0,1,1,1.313-1.312A1.313,1.313,0,0,1,4.375,12.688Zm8.75,0a1.313,1.313,0,1,1,1.312-1.312A1.313,1.313,0,0,1,13.125,12.688ZM15.313,7H11.375V3.938h1.206l2.732,2.732Z",
    transform: "translate(207 142)",
    fill: "#fc1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.0e6f43027b638ee9831bd7a467cc5578.svg";
export { ForwardRef as ReactComponent };